"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var filebar_menu_html_1 = __importDefault(require("./filebar-menu.html"));
(function (module) {
    function FileMenuController($window, $filter, report, createReportModal, renameReportModal, copyReportModal, deleteReportModal, downloadHelper, globalOptionsModal, triggerOverrides, OVERRIDE_EVENTS, portingService) {
        var $ctrl = this, translate = $filter('translate');
        var LABELS_FOR_CREATING_REPORTS = _.map([
            'DASHBOARD_MENU.NEW',
            'DASHBOARD_MENU.COPY'
        ], translate);
        angular.extend($ctrl, {
            id: 'FILE',
            label: translate('FILE'),
            getMenuItems: function () {
                var menuItems = [
                    {
                        label: translate('DASHBOARD_MENU.NEW'),
                        action: openCreateReportModal,
                        icon: 'icon-plus',
                        replaceCheck: true
                    },
                    {
                        label: translate('DASHBOARD_MENU.COPY'),
                        action: copyReportModal.show,
                        icon: 'icon-squarestack',
                        replaceCheck: true
                    },
                    {
                        label: translate('PR.EXPORT_TO_QRF'),
                        icon: 'icon-xm-download-small',
                        action: portingService.exportReport,
                        replaceCheck: true
                    },
                    {
                        label: translate('DASHBOARD_MENU.DELETE'),
                        icon: 'icon-trash-bin',
                        action: deleteReportModal.show,
                        replaceCheck: true
                    },
                    { divider: true },
                    {
                        label: translate('DASHBOARD_MENU.RENAME'),
                        action: renameReportModal.show,
                        icon: 'icon-pencil',
                        replaceCheck: true
                    },
                    {
                        label: translate('SETTINGS') + translate('ELLIPSIS'),
                        icon: 'icon-gear',
                        action: globalOptionsModal.show,
                        replaceCheck: true
                    },
                    {
                        label: translate('DASHBOARD_MENU.PAGE_SETUP'),
                        action: navigateToPageSettings,
                        icon: 'icon-wrench',
                        replaceCheck: true
                    },
                    { divider: true },
                    {
                        label: translate('HELP_LINK'),
                        icon: 'icon-question-filled-sm',
                        action: openHelpPage,
                        replaceCheck: true
                    }
                ];
                var configFlags = triggerOverrides({
                    event: OVERRIDE_EVENTS.CONFIG_FLAGS,
                    sync: true,
                    data: {}
                });
                if (configFlags.disableReportCreation) {
                    _.remove(menuItems, function (item) {
                        return _.includes(LABELS_FOR_CREATING_REPORTS, item.label);
                    });
                }
                menuItems = triggerOverrides({
                    event: OVERRIDE_EVENTS.FILE_MENU,
                    data: menuItems,
                    sync: true
                });
                return menuItems;
            }
        });
        function openCreateReportModal() {
            createReportModal.show();
        }
        function navigateToPageSettings() {
            // navigate to page tab in global options modal
            var options = { selectedIndex: 1 };
            globalOptionsModal.show(options);
        }
        function openHelpPage() {
            $window.open('https://www.qualtrics.com/support/survey-platform/reports-module/reports-section/'
                + 'paginated-reports-overview/?utm_medium=ReportsSection&utm_source=product&utm_campaign=AdvancedReportsOverview', '_blank');
        }
    }
    FileMenuController.$inject = [
        '$window',
        '$filter',
        'prActiveReport',
        'prCreateReportModal',
        'prRenameReportModal',
        'prCopyReportModal',
        'prDeleteReportModal',
        'prDownloadHelper',
        'prGlobalOptionsModal',
        'prOverrideTrigger',
        'pr.OVERRIDE_EVENTS',
        'pr.portingService'
    ];
    module.component('prFileMenu', {
        controller: FileMenuController,
        templateUrl: filebar_menu_html_1.default,
        require: {
            fbCtrl: '^^prFilebar'
        }
    });
}(angular.module('qualtrics.pr')));
